package br.com.vvrefeicoes.portal.feature.guides

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.graphics.ImageBitmap
import androidx.compose.ui.graphics.decodeToImageBitmap
import androidx.compose.ui.graphics.painter.BitmapPainter
import androidx.compose.ui.text.TextRange
import androidx.compose.ui.unit.sp
import br.com.vvrefeicoes.portal.core.di.LocalAppGraph
import com.mohamedrejeb.richeditor.annotation.ExperimentalRichTextApi
import com.mohamedrejeb.richeditor.model.ImageData
import com.mohamedrejeb.richeditor.model.ImageLoader
import com.mohamedrejeb.richeditor.model.RichSpanStyle
import com.mohamedrejeb.richeditor.model.RichTextState

private const val GUIDE_IMAGE_PREFIX = "/guides/images/"

@OptIn(ExperimentalRichTextApi::class)
internal object GuideImageLoader : ImageLoader {
    @Composable
    override fun load(model: Any): ImageData? {
        val path = model as? String ?: return null
        if (!path.startsWith(GUIDE_IMAGE_PREFIX)) return null

        val appGraph = LocalAppGraph.current
        var bitmap by remember(path) { mutableStateOf<ImageBitmap?>(null) }
        LaunchedEffect(path) {
            bitmap =
                runCatching {
                    appGraph.guideRepository.loadImage(path).decodeToImageBitmap()
                }.getOrNull()
        }
        val image = bitmap ?: return null
        return ImageData(
            painter = BitmapPainter(image),
            contentDescription = null,
        )
    }
}

@OptIn(ExperimentalRichTextApi::class)
internal fun RichTextState.insertGuideImage(url: String) {
    val index = if (selection.reversed) selection.start else selection.end
    addTextAtIndex(index, "\uFFFD")
    addRichSpan(
        spanStyle = RichSpanStyle.Image(model = url, width = 0.sp, height = 0.sp),
        textRange = TextRange(index, index + 1),
    )
    selection = TextRange(index + 1)
}
